import React from 'react'
import {Lang} from 'yougile-lang'
import {Storage} from '@client/storage'
import {Tracking, TrackingEvent} from '@common/tracking'
import {IconButton, LinkButton} from '@components/common/base/buttons'

const ExtensionsGalleryPromoBannerBase = ({
  onClick,
  onClose,
  className
}: {
  onClick: () => void
  onClose: () => void
  className?: string
}) => (
  <div
    className={`relative max-w-1096 min-w-[792px] h-[143px] flex overflow-hidden rounded-6 bg-primary ${className}`}
  >
    <div className="flex flex-col p-20">
      <div className="text-[20px] font-bold flex items-center gap-2 z-1">
        <img src="/img/banners/puzzle_emoji.png" alt="" className="h-[20px]" />
        {Lang.msg.companyDashboard.banners.extensions.title}
      </div>
      <div className="text-[14px] mt-[12px] min-w-[174px] z-1 leading-[16px]">
        {Lang.msg.companyDashboard.banners.extensions.subtitle}
      </div>
      <LinkButton onClick={onClick} className="text-[14px] mt-[4px] z-1">
        {Lang.msg.companyDashboard.banners.extensions.action}
      </LinkButton>
    </div>
    <div className="absolute right-0 bottom-0 top-0 z-[0]">
      <img
        src={'/img/crm/extension-layout.png'}
        alt=""
        className="object-contain h-full"
      />
    </div>
    <IconButton
      onClick={onClose}
      icon="IconX"
      size="small"
      wrapperSize="big"
      color="secondary"
      className="absolute right-12 top-12 text-gray-400 hover:text-black"
    />
  </div>
)

export const ExtensionsGalleryPromoBanner = ({
  setExtensionsPopupOpen,
  onClose
}: {
  setExtensionsPopupOpen: React.Dispatch<React.SetStateAction<boolean>>
  onClose: () => void
}) => {
  return (
    <ExtensionsGalleryPromoBannerBase
      onClick={() => {
        setExtensionsPopupOpen(true)
        void Tracking.send(TrackingEvent.extensionsBannerClick)
      }}
      onClose={() => {
        Storage.setItem('banner-go-to-extensions', 'closed')
        void Tracking.send(TrackingEvent.extensionsBannerHide)
        onClose()
      }}
    />
  )
}
